import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import './App.scss';
import LandingPage from './pages/LandingPage';
import PassSport from './pages/PassSport';
import PlayLocal from './pages/PlayLocal';
import SkillSharer from './pages/SkillSharer';
import SportyClub from './pages/SportyClub';
import DeepLinkRedirect from './pages/DeepLinkRedirect';
import Toast from './components/Toast';
import { isDeepLinkPath } from './utils/deepLinkPath';
import { getNotifyMessage, getNotifyPathMatch } from './utils/notifyMessage';
import ReactGA from 'react-ga4';
import { useEffect, useState } from 'react';

type NotifyLocationState = {
  notifyMessage?: string;
};

const NotifyToast = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const notifyMessage = (location.state as NotifyLocationState | null)
      ?.notifyMessage;

    if (!notifyMessage) {
      return;
    }

    setToastMessage(notifyMessage);
    setShowToast(true);
    navigate(
      { pathname: location.pathname, search: location.search },
      { replace: true, state: null },
    );
  }, [location, navigate]);

  return (
    <Toast
      testId="notify-toast"
      open={showToast}
      onClose={() => setShowToast(false)}
      title={toastMessage}
      message=""
    />
  );
};

const AppRoutes = () => {
  const location = useLocation();
  const notifySlug = getNotifyPathMatch(location.pathname);

  if (notifySlug) {
    return (
      <Navigate
        to="/"
        replace
        state={{ notifyMessage: getNotifyMessage(notifySlug) }}
      />
    );
  }

  // Central matcher: runs before catch-all so deep links never bounce to "/".
  if (isDeepLinkPath(location.pathname)) {
    return <DeepLinkRedirect />;
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/play-local" element={<PlayLocal />} />
        <Route path="/sporty-club" element={<SportyClub />} />
        <Route path="/skill-sharer" element={<SkillSharer />} />
        <Route path="/pass-sport" element={<PassSport />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <NotifyToast />
    </>
  );
};

export const App = () => {
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const source = queryParams.get('utm_source');
    ReactGA.initialize('G-K709026MPY');
    ReactGA.event({category: "route_sporti", action: `lp_view${source ? "_" + source : ""}`, label: `${window.location.pathname}${window.location.search}`});
  }, []);
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
